export const newProductPlanTypes = {
    // Get single new product plan
    FETCH_SINGLE_NEW_PRODUCT_PLAN_REQUEST: "FETCH_SINGLE_NEW_PRODUCT_PLAN_REQUEST",
    FETCH_SINGLE_NEW_PRODUCT_PLAN_SUCCESS: "FETCH_SINGLE_NEW_PRODUCT_PLAN_SUCCESS",
    FETCH_SINGLE_NEW_PRODUCT_PLAN_FAILURE: "FETCH_SINGLE_NEW_PRODUCT_PLAN_FAILURE",

    // Get new product plans list
    FETCH_NEW_PRODUCT_PLANS_REQUEST: "FETCH_NEW_PRODUCT_PLANS_REQUEST",
    FETCH_NEW_PRODUCT_PLANS_SUCCESS: "FETCH_NEW_PRODUCT_PLANS_SUCCESS",
    FETCH_NEW_PRODUCT_PLANS_FAILURE: "FETCH_NEW_PRODUCT_PLANS_FAILURE",
    REMOVE_NEW_PRODUCT_PLAN_FROM_LIST: "REMOVE_NEW_PRODUCT_PLAN_FROM_LIST",

    // Create new product plan
    CREATE_NEW_PRODUCT_PLAN_REQUEST: "CREATE_NEW_PRODUCT_PLAN_REQUEST",
    CREATE_NEW_PRODUCT_PLAN_SUCCESS: "CREATE_NEW_PRODUCT_PLAN_SUCCESS",
    CREATE_NEW_PRODUCT_PLAN_FAILURE: "CREATE_NEW_PRODUCT_PLAN_FAILURE",

    // Update new product plan
    UPDATE_NEW_PRODUCT_PLAN_REQUEST: "UPDATE_NEW_PRODUCT_PLAN_REQUEST",
    UPDATE_NEW_PRODUCT_PLAN_SUCCESS: "UPDATE_NEW_PRODUCT_PLAN_SUCCESS",
    UPDATE_NEW_PRODUCT_PLAN_FAILURE: "UPDATE_NEW_PRODUCT_PLAN_FAILURE",

    // Pin/Unpin new product plan
    PIN_NEW_PRODUCT_PLAN_REQUEST: "PIN_NEW_PRODUCT_PLAN_REQUEST",
    PIN_NEW_PRODUCT_PLAN_SUCCESS: "PIN_NEW_PRODUCT_PLAN_SUCCESS",
    PIN_NEW_PRODUCT_PLAN_FAILURE: "PIN_NEW_PRODUCT_PLAN_FAILURE",

    UNPIN_NEW_PRODUCT_PLAN_REQUEST: "UNPIN_NEW_PRODUCT_PLAN_REQUEST",
    UNPIN_NEW_PRODUCT_PLAN_SUCCESS: "UNPIN_NEW_PRODUCT_PLAN_SUCCESS",
    UNPIN_NEW_PRODUCT_PLAN_FAILURE: "UNPIN_NEW_PRODUCT_PLAN_FAILURE",

    // Cancel new product plan
    CANCEL_NEW_PRODUCT_PLAN_REQUEST: "CANCEL_NEW_PRODUCT_PLAN_REQUEST",
    CANCEL_NEW_PRODUCT_PLAN_SUCCESS: "CANCEL_NEW_PRODUCT_PLAN_SUCCESS",
    CANCEL_NEW_PRODUCT_PLAN_FAILURE: "CANCEL_NEW_PRODUCT_PLAN_FAILURE",

    // Delete new product plan
    DELETE_NEW_PRODUCT_PLAN_REQUEST: "DELETE_NEW_PRODUCT_PLAN_REQUEST",
    DELETE_NEW_PRODUCT_PLAN_SUCCESS: "DELETE_NEW_PRODUCT_PLAN_SUCCESS",
    DELETE_NEW_PRODUCT_PLAN_FAILURE: "DELETE_NEW_PRODUCT_PLAN_FAILURE",

    // Reset actions
    RESET_FETCH_SINGLE_NEW_PRODUCT_PLAN: "RESET_FETCH_SINGLE_NEW_PRODUCT_PLAN",
    RESET_FETCH_NEW_PRODUCT_PLANS: "RESET_FETCH_NEW_PRODUCT_PLANS",
    RESET_CREATE_NEW_PRODUCT_PLAN: "RESET_CREATE_NEW_PRODUCT_PLAN",
    RESET_UPDATE_NEW_PRODUCT_PLAN: "RESET_UPDATE_NEW_PRODUCT_PLAN",
    RESET_PIN_NEW_PRODUCT_PLAN: "RESET_PIN_NEW_PRODUCT_PLAN",
    RESET_UNPIN_NEW_PRODUCT_PLAN: "RESET_UNPIN_NEW_PRODUCT_PLAN",
    RESET_CANCEL_NEW_PRODUCT_PLAN: "RESET_CANCEL_NEW_PRODUCT_PLAN",
    RESET_DELETE_NEW_PRODUCT_PLAN: "RESET_DELETE_NEW_PRODUCT_PLAN",
};

export interface SimilarProduct {
    productChannel: string;
    productId: string;
    forecastStartDate?: string;
    forecastEndDate?: string;
    _id?: string;
}

export interface CreateNewProductPlanPayload {
    productId: string;
    launchDate: string;
    growthRate: number;
    additionalDetails: string;
    productChannel: string;
    similarProducts: SimilarProduct[];
}

export interface UpdateNewProductPlanPayload {
    productPlanId: string;
    productId: string;
    launchDate: string;
    growthRate: number;
    additionalDetails: string;
    productChannel: string;
    similarProducts: SimilarProduct[];
}

export interface NewProductPlanFilters {
    search?: string;
    status?: string;
    productId?: string;
    launchDateFrom?: string;
    launchDateTo?: string;
    growthRateMin?: number;
    growthRateMax?: number;
    page?: number;
    limit?: number;
    sortBy?: string;
    sortDirection?: "asc" | "desc";
}
